import merge from 'lodash.merge';

const muiTheme = {
    table: {
        backgroundColor: 'transparent'
    },
    tableRow: {
        verticalAlign: 'middle',
        spacing: 0
    },
    tableRowColumn: {
        verticalAlign: 'middle',
        spacing: 0
    },
    tableHeader: {
        height: 32,
        spacing: 0
    },
    tableHeaderColumn: {
        height: 32,
        verticalAlign: 'middle',
        spacing: 0
    }
};

const theme = merge(muiTheme);

export default theme;



// WEBPACK FOOTER //
// ./src/modules/theme/tableBaseTheme.js